import * as React from "react";
import { Route } from "react-router";

export class SimpleRoute extends Route<any> {
	public render() {
        return(
            <Route {...this.props} />
        )
	}
}